<template>
  <b-card no-body class="dashboard-card">
    <b-overlay :show="loading" rounded="sm" variant="light">
      <b-card-body class="d-flex justify-content-between align-items-center">
        <div class="truncate">
          <h6 class="mb-25 font-weight-bolder">
            {{ title }}
          </h6>
          <p>{{ description }}</p>
          <b-link v-if="$can('manage', 'chat')" class="link-underline" :to="{
            name: routeName,
            query,
          }">
            <span v-if="isCall">{{ $t("dashboard.goToCall") }}</span>
            <span v-else> {{ $t("dashboard.goToChat") }}</span>
          </b-link>
        </div>
        <h1 class="ml-1 font-weight-bolder" :class="`text-${color}`">
          {{ statistic }}
        </h1>
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BLink, BOverlay } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardBody,
    BLink,
    BOverlay,
  },
  props: {
    routeName: {
      type: String,
      default: "chat",
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    isCall: {
      type: Boolean,
      default: false
    }
  },
};
</script>
